import { useModuleBEM } from "@b2bportal/core-themes";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import { formatCurrencyWithOptions } from "@hopper-i18n/formatter";
import { getRewardsAccount, useGetAccountsRewardsQuery } from "@hsbc/rewards";
import { Loading } from "@tenant/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

export const PointsBalanceModalContent = () => {
  const { t, formatNumber } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "PointsBalanceModalContent");
  const { rewardsAccount, isLoading } = useGetAccountsRewardsQuery(undefined, {
    selectFromResult: ({ data, isLoading }) => ({
      rewardsAccount: getRewardsAccount(data),
      isLoading,
    }),
  });

  const formatOptions = {
    currencyCode: "INR",
    locale: "en-IN",
    symbol: "INR ",
  };

  const cashValue = formatCurrencyWithOptions({
    ...formatOptions,
    amount: rewardsAccount.conversionMultiplier,
    options: {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    },
  });

  // TODO: get the user tier from the API instead, currently unavailable
  const isPremier = rewardsAccount.conversionMultiplier > 0.8;

  return isLoading ? (
    <div className={clsx(block, cn("loading"))}>
      <Loading />
    </div>
  ) : (
    <div className={clsx(block)}>
      <div className={cn("available-points-title")}>
        {t("rewardsPointsModal.availablePoints")}
      </div>
      <div className={cn("points-balance")}>
        {`${formatNumber(rewardsAccount.pointsBalance.value)} = ${formatCurrencyWithOptions(
          {
            ...formatOptions,
            amount: rewardsAccount.cashEquivalent?.value ?? 0,
          }
        )}`}
      </div>
      <div className={cn("points-description")}>
        {isPremier ? (
          <Trans
            i18nKey="rewardsPointsModal.premierDescription"
            values={{ cashValue }}
            components={[<span className={cn("bold")} />]}
          />
        ) : (
          <Trans
            i18nKey="rewardsPointsModal.nonPremierDescription"
            values={{ cashValue }}
            components={[<span className={cn("bold")} />]}
          />
        )}
      </div>
    </div>
  );
};
